import { render, staticRenderFns } from "./LaudoSupressaoVegetalRedYellowFlagModal.vue?vue&type=template&id=fa397e60&scoped=true&lang=pug"
import script from "./LaudoSupressaoVegetalRedYellowFlagModal.vue?vue&type=script&lang=js"
export * from "./LaudoSupressaoVegetalRedYellowFlagModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoSupressaoVegetalRedYellowFlagModal.vue?vue&type=style&index=0&id=fa397e60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa397e60",
  null
  
)

export default component.exports